module.exports = __webpack_public_path__ + "img/16581259_L.2eb53fc8.png";